import React, { useEffect, useState, useContext } from 'react'
import WizardSteps from '@/components/common/wizard/WizardSteps'
import { useWizard } from '@/components/mediaBuying/adCreatives/AdCreativeWizard'
import { LeadFormQuestionsView } from './instantForm/LeadFormQuestionsView'
import { useMediaBuyingContext } from '@/context/media-buying-context.jsx'
import { SettingsContext } from '@/context/settings-context.jsx'
import { usePageData } from '../hooks'
import { Input } from '@/components/ui'
import { FORM_TYPES as formTypes, DEFAULT_FORM_TYPE } from '../leadFormType'

export const FormType = () => {
    const { getStepContentData, setStepContentData, dataForStepper } = useWizard()
    const { connectedPublishers } = useMediaBuyingContext()
    const { theme } = useContext(SettingsContext)
    const { pageIcon, pageTitle } = usePageData(connectedPublishers)

    const [formName, setFormName] = useState('')
    const [formType, setFormType] = useState(DEFAULT_FORM_TYPE)

    useEffect(() => {
        const saved = getStepContentData() || {}
        const now = new Date()
        const defaultName = `Untitled Form ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
        setFormName(saved.formName || defaultName)
        setFormType(saved.formType || DEFAULT_FORM_TYPE)
    }, [])

    useEffect(() => {
        setStepContentData({
            formName,
            formType,
        })
    }, [formName, formType])

    return (
        <div className="tw:flex tw:h-full">
            <WizardSteps adCreative={dataForStepper} currentStep="formType" />
            <div className={`d-flex h-100 ${theme} campaigns-container w-100`}>
                <div className="flex-grow-1 border-right-white-1 overflow-auto pt-4 tw:px-4">
                    <div className="mb-4 ">
                        <div className="tw:flex tw:flex-col tw:gap-2">
                            <label className="tw:text-sm tw:font-semibold tw:mb-1">Form Name</label>
                            <div className="tw:text-sm">The name that you choose will only be seen in Ads Manager.</div>
                            <Input
                                type="text"
                                className=""
                                value={formName}
                                onChange={(e) => setFormName(e.target.value)}
                                placeholder="Ex. Sign up"
                            />
                        </div>
                    </div>

                    <div className="px-2 tw:flex tw:flex-col tw:gap-3">
                        <label className="tw:text-sm tw:font-semibold tw:mb-1">Form Volume</label>
                        <label className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="formType"
                                id="formTypeMore"
                                checked={formType === formTypes.higherVolume}
                                onChange={() => setFormType(formTypes.higherVolume)}
                                style={{ cursor: 'pointer' }}
                            />
                            <div className="tw:flex tw:flex-col tw:gap-1">
                                <span className="tw:text-sm" htmlFor="formTypeMore">
                                    More Volume
                                </span>
                                <div className="tw:text-sm">
                                    Use a form that's quick to fill in and submit on a mobile device.
                                </div>
                            </div>
                        </label>
                        <label className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="formType"
                                id="formTypeIntent"
                                checked={formType === formTypes.higherIntent}
                                onChange={() => setFormType(formTypes.higherIntent)}
                                style={{ cursor: 'pointer' }}
                            />
                            <div className="tw:flex tw:flex-col tw:gap-1">
                                <span className="tw:text-sm" htmlFor="formTypeIntent">
                                    Higher Intent (With confirmation screen)
                                </span>
                                <div className="tw:text-sm">
                                    Add a review step that gives people a chance to confirm their information.
                                </div>
                            </div>
                        </label>
                    </div>
                </div>

                <div className="position-relative tw:p-6" style={{ width: 320, maxWidth: 320 }}>
                    <LeadFormQuestionsView
                        theme={theme}
                        questions={[]}
                        pageTitle={pageTitle}
                        pageIcon={pageIcon}
                        hideSelectForm={true}
                    />
                </div>
            </div>
        </div>
    )
}
